import { render, staticRenderFns } from "./tableCustom.vue?vue&type=template&id=4758f6e5&scoped=true&"
import script from "./tableCustom.vue?vue&type=script&lang=js&"
export * from "./tableCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4758f6e5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2023/thShop/thShopAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4758f6e5')) {
      api.createRecord('4758f6e5', component.options)
    } else {
      api.reload('4758f6e5', component.options)
    }
    module.hot.accept("./tableCustom.vue?vue&type=template&id=4758f6e5&scoped=true&", function () {
      api.rerender('4758f6e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/rw/tempTable/components/tableCustom.vue"
export default component.exports